import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  DashboardProspectsFormSchema,
  RegisterUserStepMutation,
} from './DashboardProspectsCOMForm.types';
import { useMutation, useQueryClient } from 'react-query';
import Form from '../../../../../commons/Form/Form';
import { createProspectStepData } from './DashboardProspectsCOMForm.data';
import { getCreateProspectSchema } from './DashboardProspectsCOMForm.schema';
import { CREATE_PROSPECT_QUERY_KEY, createProspectQuery } from './DashboardProspectsCOMForm.query';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const formProps = useForm<DashboardProspectsFormSchema>({
    resolver: yupResolver(getCreateProspectSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<
    Awaited<ReturnType<RegisterUserStepMutation>>,
    Error,
    DashboardProspectsFormSchema
  >((data) => createProspectQuery(data), {
    mutationKey: CREATE_PROSPECT_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      navigate(0);
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<DashboardProspectsFormSchema>
        data={createProspectStepData}
        {...{ formProps, onSubmit }}
      />
    </>
  );
};
